import { combineReducers } from "redux";
import authReducer from "./auth";
import commonReducer from "./common";
import requestReducer from "./requests";
import sitesReducer from "./sites";
import locationReducer from "./locations";
import doorsReducer from "./doors";
import approversReducer from "./approvers";
import dashboardReducer from "./dashboard";
import delegationReducer from "./delegation";
import reportReducer from "./report";
import employeeReducer from "./employee";
import delegationByAdminReducer from "./delegationByAdmin"
const rootReducer = combineReducers({
  auth: authReducer,
  common: commonReducer,
  request: requestReducer,
  site: sitesReducer,
  doors: doorsReducer,
  location: locationReducer,
  approver: approversReducer,
  dashboard: dashboardReducer,
  delegation: delegationReducer,
  report:reportReducer,
  employee:employeeReducer,
  delegationByAdmin:delegationByAdminReducer
});

export default rootReducer;



